export const Permissions = {
  CREATE_PROJECT: 'CREATE_PROJECT',
  EDIT_PROJECT: 'EDIT_PROJECT',
  DELETE_PROJECT: 'DELETE_PROJECT',
  APPROVE_PROJECT: 'APPROVE_PROJECT',
  VIEW_ALL_PROJECTS: 'VIEW_ALL_PROJECTS',
  MANAGE_USERS: 'MANAGE_USERS',
  PERFORM_MEASUREMENTS: 'PERFORM_MEASUREMENTS',
} as const;
export const Roles = {
  NONE: 'NONE',
  ADMINISTRATOR: 'ADMINISTRATOR',
  BACK_OFFICE: 'BACK_OFFICE',
  FIELD_AGENT: 'FIELD_AGENT',
} as const;
